<script>
import { required } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import AccountModal from "./account-modal.vue";
import SLModal from "./sl-modal.vue";

export default {
    name: "JevModal",
    props: {
        modalTitle: String,
        journalType: {
            type: String,
            default: 'General Journal'
        },
        fundSources: {
            type: Array,
            default: () => []
        },
        accounts: {
            type: Array,
            default: () => []
        }
    },
    components: {
        DatePicker,
        MaskedInput,
        AccountModal,
        SLModal
    },
    validations: {
        form: {
            journalDateTime: {required},
            description: {required},
            fundSourceId: {required}
        }
    },
    data(){
        return {
            submitAcc: false,
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
            form: {
                id: 0,
                journalDateTime: new Date(),
                notes: null,
                description: null,
                sourceDocument: null,
                fundSourceId: null,
                journalEntryDetails: [],
            },
            newAcc: {
                id: 0,
                account: "",
                accountId: 0,
                debit: '',
                credit: '',
                accountSearch: '',
                searched: false,
                failedSearch: false,
                subsidiaryLedgerId: 0,
                slCode: '',
            },
            submitted: false,
            loadJEVNumber: false,
        }
    },
    computed: {
        totalDebit() {
            return this.form.journalEntryDetails.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
        },
        totalCredit() {
            return this.form.journalEntryDetails.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);
        },
        fundSourceOptions() {
            return [
                { value: 0, text: 'Select Fund Source...', disabled: true },
                ...this.fundSources.map(fs => ({ value: fs.id, text: fs.sourceName }))
            ];
        },
        accountOptions() {
            return [
                { value: 0, text: 'Select Account...', disabled: true },
                ...this.accounts.map(acc => ({ value: acc.id, text: `${acc.code} - ${acc.name}` }))
            ];
        },
        isEditingAccount(){
            return this.form.journalEntryDetails.some(item => item.isEdit);
        }
    },
    methods: {
        updateData(data){
            this.form = cloneDeep(data);
            this.submitted = false;
        },
        updateDetails(data){
            this.form.journalEntryDetails = cloneDeep(data);
        },
        resetForm(){
            this.form = {
                id: 0,
                journalDateTime: new Date(),
                notes: null,
                description: null,
                sourceDocument: null,
                fundSourceId: null,
                journalEntryDetails: [],
            }
            this.newAcc = {
                id: 0,
                account: "",
                accountId: 0,
                debit: '',
                credit: '',
                accountSearch: '',
                subsidiaryLedgerId: 0,
                isSundry: false,
                searched: false,
                failedSearch: false,
                slCode: '',
            }
            this.submitAcc = false;
            this.submitted = false;
            this.$v.$reset();
        },
        onCreate(createAndPost = false){
            this.submitted = true;
            this.$v.form.$touch();
            if(this.$v.form.$invalid) return;
            if(this.form.journalEntryDetails.length === 0) {
                this.$swal({
                    icon: 'error',
                    title: 'No Journal Details',
                    text: 'Please add at least one journal entry detail'
                });
                return;
            }
            let data = cloneDeep(this.form);
            data.createAndPost = createAndPost;
            data.journalDateTime = this.getDate(this.form.journalDateTime);
            data.journalEntryDetails = data.journalEntryDetails.map(item => {
                return {
                    ...item,
                    debit: this.getExactAmt(item.debit) || 0,
                    credit: this.getExactAmt(item.credit) || 0,
                    isSundry: item.isSundry || false
                };
            });
            this.$emit('submit', data);
        },
        removeJevDetail(index) {
            this.form.journalEntryDetails.splice(index, 1);
        },
        onAccountChange(index, accountId) {
            const account = this.accounts.find(acc => acc.id === accountId);
            if (account) {
                this.$set(this.form.journalEntryDetails, index, {
                    ...this.form.journalEntryDetails[index],
                    accountId: accountId,
                    account: `${account.code} - ${account.name}`
                });
            }
        },
        getTotalDebit() {
            return this.form.journalEntryDetails.reduce((total, item) => {
                return total + parseFloat(item.debit || 0);
            }, 0);
        },
        getTotalCredit() {
            return this.form.journalEntryDetails.reduce((total, item) => {
                return total + parseFloat(item.credit || 0);
            }, 0);
        },
        searchAccount(item){
            if(item){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
            this.$bvModal.show("search-account-modal");
        },
        resetItem() {
            this.newAcc = {
                id: 0,
                account: "",
                accountId: 0,
                debit: '',
                credit: '',
                isSundry: false
            };
        },
        selectAccount(account) {
            if(this.selectedItem){
                this.selectedItem.accountId = account.id;
                this.selectedItem.account = account.account;
                this.selectedItem.uacs = account.uacs;
            }else{
                this.newAcc.accountId = account.id;
                this.newAcc.account = account.account;
                this.newAcc.uacs = account.uacs;
                this.newAcc.searched = true;
                this.newAcc.failedSearch = false;
            }
        },
        findAccount(){
            let searchAcc = this.accounts.find(item => item.uacs.replace(/ /g,'') === this.newAcc.accountSearch.replace(/ /g,''));
            if(searchAcc){
                this.newAcc.accountId = searchAcc.id;
                this.newAcc.account = searchAcc.account;
                this.newAcc.uacs = searchAcc.uacs;
                this.newAcc.searched = true;
                this.newAcc.failedSearch = false;
                this.$refs.accDebitAdd.$el.focus();
            }else{
                this.newAcc.accountId = null;
                this.newAcc.account = '';
                this.newAcc.uacs = '';
                this.newAcc.searched = false;
                this.newAcc.failedSearch = true;
            }
        },
        async addToJev(){
            if(this.newAcc.accountId == 0 || this.newAcc.debit === '' && this.newAcc.credit === '') return this.submitAcc = true;
            let dat = cloneDeep(this.newAcc);
            dat.debit = this.getExactAmt(this.newAcc.debit);
            dat.credit = this.getExactAmt(this.newAcc.credit);
            dat.isEdit = false;
            this.form.journalEntryDetails.push(dat);
            this.resetItem();
            await this.wait(100);
            this.$refs.accountSearch.focus();
            this.submitAcc = false;
        },
        editItem(item) {
            item.isEdit = true;
            this.copyAcc = cloneDeep(item);
        },
        editToJev(item, index){
            if(item.accountId == 0 || item.debit === '' && item.credit === '') return this.submitAcc = true;
            let dat = cloneDeep(item);
            dat.debit = this.getExactAmt(item.debit);
            dat.credit = this.getExactAmt(item.credit);
            dat.isEdit = false;
            this.form.journalEntryDetails.splice(index, 1, dat);
            this.$refs.accountSearch.focus();
            this.submitAcc = false;
        },
        resetUpdateItem(index) {
            this.form.journalEntryDetails.splice(index, 1, {...this.copyAcc, isEdit: false});
        },
        deleteItem(index) {
            this.form.journalEntryDetails.splice(index, 1);
        },
        addSL(type, item = null){
            this.selectedItem = item;
            this.slTagType = type;
            this.$bvModal.show("sl-modal");
        },
        selectSL(data){
            if(this.slTagType === 'new'){
                this.newAcc.subsidiaryLedgerId = data.id;
                this.newAcc.slCode = data.code;
                this.newAcc.subsidiaryLedger = data;
            }else{
                this.selectedItem.subsidiaryLedgerId = data.id;
                this.selectedItem.slCode = data.code;
                this.selectedItem.subsidiaryLedger = data;
            }
        },
        removeSL(item){
            item.subsidiaryLedgerId = 0;
            item.slCode = '';
        },
    }
}
</script>

<template>
    <b-modal
        id="jev-modal"
        :title="modalTitle"
        size="xl"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate(false)"
            class="needs-validation"
            ref="fcForm"
        >
            <!-- Main Form Fields -->
            <div class="row">
                <!-- Left Column -->
                <div class="col-md-4">
                    <div class="mb-3">
                        <label for="journalDateTime">Journal Entry Date </label>
                        <date-picker
                            id="journalDateTime"
                            v-model="form.journalDateTime"
                            :first-day-of-week="1"
                            lang="en"
                            placeholder="Enter Journal Entry Date..."
                            format="MMMM DD, YYYY"
                            :class="{
                                'is-invalid': submitted && $v.form.journalDateTime.$error,
                            }"
                        />
                        <div
                            v-if="submitted && $v.form.journalDateTime.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.journalDateTime.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                
                <div class="col-md-4">
                    <div class="mb-3">
                        <label for="fundSource">Fund Source </label>
                        <b-form-select
                            class="form-select"
                            id="fundSource"
                            v-model="form.fundSourceId"
                            :options="fundSourceOptions"
                            autocomplete="off"
                            :class="{
                                'is-invalid': submitted && $v.form.fundSourceId.$error,
                            }"
                        />
                        <div
                            v-if="submitted && $v.form.fundSourceId.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.form.fundSourceId.required">This value is required.</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="mb-3">
                        <label for="sourceDocument">Source Document</label>
                        <b-form-input
                            id="sourceDocument"
                            v-model="form.sourceDocument"
                            placeholder="Enter Source Document..."
                            autocomplete="off"
                        />
                    </div>
                </div>
            </div>
            <div class="mb-3 row">
                <div class="col-md-6">
                    <label for="description">Description </label>
                    <b-form-textarea
                        id="description"
                        v-model="form.description"
                        placeholder="Enter Description..."
                        rows="3"
                        autocomplete="off"
                        :class="{
                            'is-invalid': submitted && $v.form.description.$error,
                        }"
                    />
                    <div
                        v-if="submitted && $v.form.description.$error"
                        class="invalid-feedback"
                    >
                        <span v-if="!$v.form.description.required">This value is required.</span>
                    </div>
                </div>
                <div class="col-md-6">
                    <label for="notes">Notes</label>
                    <b-form-textarea
                        id="notes"
                        v-model="form.notes"
                        placeholder="Enter Notes..."
                        rows="3"
                        autocomplete="off"
                    />
                </div>
            </div>
            <!-- Journal Entry Details Section -->
            <hr />
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="mb-0">Journal Entry Details</h5>
            </div>
            <table class="table table-sm align-middle table-bordered border-primary mb-0">
                <thead>
                    <tr>
                        <th >UACS</th>
                        <th>Account Name</th>
                        <th class="text-center"  style="width:150px;">Debit</th>
                        <th class="text-center"  style="width:150px;">Credit</th>
                        <th class="text-center">SL</th>
                        <!-- <th class="text-center"  style="width:90px;">Sundry</th> -->
                        <th class="text-center" style="width:90px;">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="(item, index) in form.journalEntryDetails"
                        :key="index"
                    >
                        <td class="col-md-2" scope="row">
                            <template v-if="!item.isEdit">{{ item.uacs }}</template>
                            <template v-else>
                                <b-form-input
                                    v-model="item.uacs"
                                    placeholder="Enter UACS"
                                ></b-form-input>
                            </template>
                        </td>
                        <td class="col-md-4">
                            <template v-if="!item.isEdit">{{ item.account }}</template>
                            <template v-else>
                                <b-input-group>
                                    <template #append>
                                        <b-button
                                            type="button"
                                            @click="searchAccount(item)"
                                            variant="outline-info"
                                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                                        ></b-button>
                                    </template>
                                    <b-form-input
                                        v-model="item.account"
                                        placeholder="Enter Account Name"
                                    ></b-form-input>
                                </b-input-group>
                            </template>
                        </td>
                        <td class="text-center">
                            <template v-if="!item.isEdit">{{item.debit ? formatCurrency(item.debit) : '-'}}</template>
                            <template v-else>
                                <form @submit.prevent="editToJev(item, index)">
                                    <masked-input
                                        ref="accDebit"
                                        autocomplete="off"
                                        type="text"
                                        v-model="item.debit"
                                        class="form-control me-1 text-center form-control-sm"
                                        :mask="currencyMask"
                                        :class="{'is-invalid': submitAcc && !item.debit}"
                                    >
                                    </masked-input>
                                </form>
                            </template>
                        </td>
                        <td class="text-center">
                            <template v-if="!item.isEdit">{{item.credit ? formatCurrency(item.credit) : '-'}}</template>
                            <template v-else>
                                <form @submit.prevent="editToJev(item, index)">
                                    <masked-input
                                        autocomplete="off"
                                        type="text"
                                        v-model="item.credit"
                                        class="form-control me-1 text-center form-control-sm"
                                        :mask="currencyMask"
                                        :class="{'is-invalid': submitAcc && !item.credit}"
                                    >
                                    </masked-input>
                                </form>
                            </template>
                        </td>
                        <!-- <td class="text-center">
                            <div class="form-check form-checkbox-outline form-check-success mb-0 d-flex justify-content-center align-items-center">
                                <input
                                    type="checkbox"
                                    class="form-check-input cb-large position-relative"
                                    v-model="item.isSundry"
                                    :disabled="!item.isEdit"
                                />
                            </div>
                        </td> -->
                        <td class="text-center cursor-pointer" id="for subsidiaryLedgerId" @click="addSL('old', item)">
                            <template v-if="!item.subsidiaryLedgerId">
                                <a href="javascript:void(0);">Tag SL</a>
                            </template>
                            <template v-else>
                                <a href="javascript:void(0);" class="font-size-14 mb-0" :id="`A-${index}`">{{ item.subsidiaryLedger }}</a>
                                <b-popover :target="`A-${index}`" placement="left" triggers="hover focus">
                                    <template #title>Subsidiary Ledger</template>
                                    <div class="text-truncate">{{ item.slCode }}</div>
                                    <div class="font-size-13 text-success font-weight-bold">{{ item.subsidiaryLedger.clientDto ? item.subsidiaryLedger.clientDto.name : item.subsidiaryLedger }}</div>
                                    <div>{{item.subsidiaryLedger.slType }}</div>
                                </b-popover>
                                <a href="javascript:void(0);" @click.stop="removeSL(item)" class="text-danger ms-1"><i class="bx bx-x"></i></a>
                            </template>
                        </td>
                        <td class="text-center col-md-1">
                            <template v-if="!item.isEdit">
                                <a href="javascript:void(0)" @click="editItem(item)" v-if="!isEditingAccount">
                                    <i class="bx bx-edit text-success font-size-22 "></i>
                                </a>
                                <a href="javascript:void(0)" @click="deleteItem(index)" v-if="!isEditingAccount">
                                    <i class="bx bx-trash text-danger font-size-22 "></i>
                                </a>
                            </template>
                            <template v-if="item.isEdit">
                                <a href="javascript:void(0)" @click="editToJev(item, index)" >
                                    <i class="bx bx-check me-2 text-green font-size-22 "></i>
                                </a>
                                <a href="javascript:void(0)" @click="resetUpdateItem(index)" >
                                    <i class="bx bx-x text-danger font-size-22 "></i>
                                </a>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <template v-if="!newAcc.accountId">
                            <td colspan="2">
                                <form @submit.prevent="findAccount">
                                    <b-input-group>
                                        <template #append>
                                        <b-button
                                            type="button"
                                            @click="searchAccount(null)"
                                            variant="outline-info"
                                            :disabled="isEditingAccount"
                                            ><i class="mdi mdi-clipboard-text-search-outline"></i
                                        ></b-button>
                                        </template>
                                        <input 
                                            ref="accountSearch"
                                            autocomplete="off"
                                            type="text" 
                                            class="form-control" 
                                            placeholder="Type the UACS or Search Account" 
                                            v-model="newAcc.accountSearch"
                                            :disabled="isEditingAccount"
                                            :class="{'is-invalid': newAcc.accountSearch && newAcc.failedSearch}"
                                        >
                                    </b-input-group>
                                    <span v-if="newAcc.accountSearch && newAcc.failedSearch">
                                        <small class="text-danger" v-if="newAcc.failedSearch">Account not found</small>
                                    </span>
                                </form>
                            </td>
                        </template>
                        <template v-else>
                            <td>{{newAcc.uacs}}</td>
                            <td>{{newAcc.account}}</td>
                        </template>
                        <td>
                            <form @submit.prevent="addToJev">
                                <masked-input
                                    ref="accDebitAdd"
                                    autocomplete="off"
                                    type="text"
                                    v-model="newAcc.debit"
                                    :disabled="isEditingAccount"
                                    class="form-control me-1 text-center form-control-sm"
                                    :mask="currencyMask"
                                    :class="{'is-invalid': submitAcc && !newAcc.debit}"
                                >
                                </masked-input>
                            </form>
                        </td>
                        <td>
                            <form @submit.prevent="addToJev">
                                <masked-input
                                    autocomplete="off"
                                    type="text"
                                    v-model="newAcc.credit"
                                    class="form-control me-1 text-center form-control-sm"
                                    :mask="currencyMask"
                                    :disabled="isEditingAccount"
                                    :class="{'is-invalid': submitAcc && !newAcc.credit}"
                                >
                                </masked-input>
                            </form>
                        </td>
                        <!-- <td class="text-center" @click="newAcc.isSundry = !newAcc.isSundry">
                            <div class="form-check form-checkbox-outline form-check-success mb-0 d-flex justify-content-center align-items-center">
                                <input
                                    type="checkbox"
                                    class="form-check-input cb-large position-relative"
                                    v-model="newAcc.isSundry"
                                />
                            </div>
                        </td> -->
                        <td class="text-center" id="for subsidiaryLedgerId" @click="addSL('new')">
                            <template v-if="!newAcc.subsidiaryLedgerId && newAcc.accountId && (newAcc.debit !== '' || newAcc.credit !== '')">
                                <a href="javascript:void(0);">Tag SL</a>
                            </template>
                            <template v-if="newAcc.subsidiaryLedgerId">
                                <span class="badge bg-info font-size-12">{{ newAcc.slCode }}</span>
                                <a href="javascript:void(0);" @click="removeSL(newAcc)">Remove</a>
                            </template>
                        </td>
                        <td class="text-center">
                            <template v-if="newAcc.accountId != 0 || newAcc.debit != '' || newAcc.credit != ''">
                                <a href="javascript:void(0)" @click="addToJev" >
                                    <i class="bx bx-check me-2 text-green font-size-24 "></i>
                                </a>
                                <a href="javascript:void(0)" @click="resetItem" >
                                    <i class="bx bx-x text-danger font-size-24 "></i>
                                </a>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" class="text-right">Total:</td>
                        <td class="text-center">{{ formatCurrency(getTotalDebit()) }}</td>
                        <td class="text-center">{{ formatCurrency(getTotalCredit()) }}</td>
                        <td colspan="2"></td>
                    </tr>
                </tbody>
            </table>

            <!-- Modal Footer -->
            <hr />
            <div class="text-end">
                <b-dropdown
                    id="dropdown-dropleft"
                    right
                    variant="link"
                    toggle-class="text-decoration-none"
                    menu-class="dropdown-menu-end"
                    no-caret
                    v-if="form.id === 0"
                >
                    <template #button-content>
                        <button type="button" class="btn btn-primary" :disabled="form.journalEntryDetails.length === 0">
                            <i class="bx bx-save me-1"></i>
                            Save
                        </button>
                    </template>
                    <b-dropdown-item
                        @click="onCreate(false)"
                        ><i class="bx bx-receipt me-1"></i> Save As Draft</b-dropdown-item
                    >
                    <b-dropdown-item
                        @click="onCreate(true)"
                        ><i class="bx bx-check me-1"></i> Save &amp; Post</b-dropdown-item
                    >
                </b-dropdown>
                 <button type="button" class="btn btn-primary" @click="onCreate(true)" v-else>
                    <i class="bx bx-save me-1"></i>
                    Update
                </button>
                <button
                    type="button"
                    class="btn btn-link ms-2"
                    @click="$bvModal.hide('jev-modal')"
                >
                    Cancel
                </button>
            </div>
        </form>
        <AccountModal 
            :accounts="accounts"
            @select-account="selectAccount"
        />
        <SLModal  @selectSubsidiaryLedger="selectSL"/>
    </b-modal>
</template>

<style scoped>
.table th, .table td {
    vertical-align: middle;
}

.font-size-48 {
    font-size: 48px;
}

.is-invalid .mx-datepicker {
    border: 1px solid #f46a6a;
}
</style>